export class UserCreditCardRequest {
  holderName: string;      // Obrigatório
  number: string;          // Obrigatório
  expiryMonth: string;     // Obrigatório: "MM"
  expiryYear: string;      // Obrigatório: "YYYY"
  ccv: string;             // Obrigatório

  name: string;            // Obrigatório: nome do titular (igual ao holderName)
  email: string;           // Obrigatório
  cpfCnpj: string;         // Obrigatório
  postalCode: string;      // Obrigatório
  addressNumber: string;   // Obrigatório
  addressComplement?: string; // Opcional
  phone?: string;          // Opcional
  mobilePhone: string;     // Obrigatório
  saveCreditCard: boolean; // Obrigatório
  remoteIp: string;        // Obrigatório
}

export class BookPaymentRequest {
  idBookVersion: number;
  idPaymentMethodInstallment: number;
  idUserCreditCard?: number | null | undefined; // só vai se selecionar cartão já salvo
  userCreditCard?: UserCreditCardRequest; // só vai se for novo cartão
}